// Module
var code = "<booth-setting-layout sub-location=\"'product'\"> <remote-paged-grid-layout ng-if=\"query\" new-entity-enabled=\"false\" columns=\"columns\" find-page=\"findPage\" query=\"query\" sort-info=\"sortInfo\" enable-row-dbl-click=\"false\"></remote-paged-grid-layout> </booth-setting-layout> ";
// Exports
export default code;